import http from "./HttpService";
import { API_BASE_CAMPAIGN, API_BASE_CONTENT } from "../../constants/index";
import axios from "axios";
import { getQueryEmailId } from "modules/EmailBrowser/utils";

let cancelTokenDraftEmails: any;
export function getEmailsService(campaignId: number, queryParams: any) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenDraftEmails != typeof undefined) {
    cancelTokenDraftEmails && cancelTokenDraftEmails.cancel("Operation canceled due to new request.");
  }

  //Save the cancel token for the current request
  cancelTokenDraftEmails = axios.CancelToken.source();
  let url = `${API_BASE_CAMPAIGN}get_draft_emails/${campaignId}/?${queryParams}`;
  return http.get(
    url,
    { cancelToken: cancelTokenDraftEmails.token } //Pass the cancel token to the current request
  );
}

let cancelTokenSentEmails: any;
export function getSentEmailService(campaignId: number, queryParams: any) {
  if (typeof cancelTokenSentEmails != typeof undefined) {
    cancelTokenSentEmails && cancelTokenSentEmails.cancel("Operation canceled due to new request.");
  }
  cancelTokenSentEmails = axios.CancelToken.source();
  let url = `${API_BASE_CAMPAIGN}get_versions/?${queryParams}`;
  return http.get(
    url,
    { cancelToken: cancelTokenSentEmails.token } //Pass the cancel token to the current request
  );
}

let cancelTokenScheduledEmails: any;
export function getScheduledEmailService(campaignId: number, queryParams: any) {
  if (typeof cancelTokenScheduledEmails != typeof undefined) {
    cancelTokenScheduledEmails && cancelTokenScheduledEmails.cancel("Operation canceled due to new request.");
  }
  cancelTokenScheduledEmails = axios.CancelToken.source();
  let url = `${API_BASE_CAMPAIGN}get_scheduled_emails/${campaignId}/?${queryParams}`;
  return http.get(
    url,
    { cancelToken: cancelTokenScheduledEmails.token } //Pass the cancel token to the current request
  );
}

let cancelTokenPreview: any;
export function getPreviewArticlesService(article_id: string) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenPreview != typeof undefined) {
    cancelTokenPreview && cancelTokenPreview.cancel("Operation canceled due to new request.");
  }

  //Save the cancel token for the current request
  cancelTokenPreview = axios.CancelToken.source();

  let assetId = getQueryEmailId();
  return http.get(
    `${API_BASE_CONTENT}get_article_preview/?version_id=${assetId}&article_id=${article_id}`,
    { cancelToken: cancelTokenPreview.token } //Pass the cancel token to the current request
  );
}

export const resendOptionsService = async (resendOption: string, emailId?: string, generationId?: string) => {
  const payload = new FormData();
  if (emailId) payload.append('email_id', emailId);
  if (generationId) payload.append('generation_id', generationId);
  if (resendOption) payload.append('resend_options', resendOption);
  return await http.post(`${API_BASE_CAMPAIGN}resend_email/`, payload, {});
};
